import { fetchFormData, fetchFormDropdownData } from '../../api/rulesAndData';

export async function loadValidationRules() {
  try {
    const data = await fetchFormData();
    // console.log('Fetched validation rules:', data); // debug
    return data || {}; // fallback to empty object if data is null
  } catch (error) {
    console.error('Failed to load rules:', error);
    return {}; // safer fallback
  }
}

export async function loadDropdownData({ gender }) {
  try {
    const data = await fetchFormDropdownData();

    if (!data) return {};
    // console.log('Fetched dropdown data:', data); // debug
    const normalizedGender = gender?.toLowerCase();

    // Neutral / default
    if (!normalizedGender) {
      return data;
    }

    // Female-specific filtering
    if (normalizedGender === 'femenino') {
      const skills = data.skill_level_choices ?? [];

      return {
        ...data,
        skill_level_choices: skills.filter(
          opt => opt.for?.toLowerCase() !== 'masculino'
        )
      };
    }

    // Male or other genders → full data (for now)
    return data;
  } catch (error) {
    console.error('Failed to load dropdown data:', error);
    return {};
  }
}


